import { contactPageQueryOptions } from "@data/publicPageDataQuery"
import { SiteShell } from "@shared/ui/SiteShell"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/routeHead"
import { ContactPage } from "./-ContactPage"

export const Route = createFileRoute("/$locale/contact/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(contactPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "contact", path: `/${locale}/contact` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <SiteShell>
      <ContactPage data={data} />
    </SiteShell>
  )
}
